// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"355":"footer-mobile-menu","360":"footer-ad","434":"header-mobile-navigation","545":"shows-format-time","560":"header-sticky","592":"sportradar-scoreboard"}[chunkId] + ".js";
};